var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('figure',{staticClass:"item en",staticStyle:{"margin":"auto","text-align":"center"}},[_c('figcaption',[_vm._v("LimitYangのblog")])])])
}]

export { render, staticRenderFns }